const config = {
	apiBaseUrl: "https://tarms-api.teamshareskorea.co.kr", //import.meta.env.VITE_API_BASE_URL,
	appName: import.meta.env.VITE_APP_NAME,
	kakaoKey: "9ab9984272e579cc66a888ce231dbadc"
};

export default config;
